@import '../../../theme.scss';

verdocs-button {
  button {
    font-family: $verdocs-primary-font;
    justify-content: center;
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
    margin: 0;
    width: 100%;

    &:disabled {
      cursor: inherit;
      pointer-events: none;
    }

    .icon {
      margin: 0 12px;

      svg {
        fill: $verdocs-grey-4;
        display: block;
      }
    }

    .button-label {
      padding: 0 12px;
    }

    // Small-sized button size adjustments
    &.xsmall {
      height: 26px;
      font-size: 12px;

      .icon {
        margin: 0 3px;

        svg {
          margin: 2px 0 0 0;
          height: 18px;
        }
      }

      .button-label {
        padding: 0 4px;
      }
    }

    // Small-sized button size adjustments
    &.small {
      height: 34px;
      font-size: 13px;

      .icon {
        margin: 0 4px;

        svg {
          margin: 2px 0 0 0;
          height: 20px;
        }
      }

      .button-label {
        padding: 0 4px;
      }
    }

    // Normal-sized button size adjustments
    &.normal {
      height: 44px;
      font-size: 14px;

      .icon.start {
        margin: 0 4px 0 8px;
      }

      .icon.end {
        margin: 0 8px 0 4px;
      }

      .icon {
        svg {
          margin: 2px 0 0 0;
          height: 22px;
        }
      }

      .button-label {
        padding: 0 10px;
      }
    }

    // Medium-sized button size adjustments
    &.medium {
      height: 52px;
      font-size: 16px;

      .icon.start {
        margin: 0 0 0 18px;
      }

      .icon.end {
        margin: 0 18px 0 0;
      }

      .icon {
        svg {
          margin: 2px 0 0 0;
          height: 26px;
        }
      }

      .button-label {
        padding: 0 20px;
      }
    }

    // Large-sized button size adjustments
    &.large {
      height: 60px;
      font-size: 20px;

      .icon.start {
        margin: 0 0 0 24px;
      }

      .icon.end {
        margin: 0 24px 0 0;
      }

      .icon {
        svg {
          margin: 2px 0 0 0;
          height: 32px;
        }
      }

      .button-label {
        padding: 0 34px;
      }
    }

    // Standard variant is a solid color
    &.standard {
      background: $verdocs-green;
      border-radius: 4px;
      outline: none;
      border: none;
      color: white;

      &:disabled {
        background-color: $disabled-color;
        cursor: default;
      }

      &:active:not([disabled]) {
        filter: brightness(110%);
      }
    }

    // Text variant is just a label
    &.text {
      color: $secondary-color;
      background: transparent;
      font-weight: 500;
      padding: 0 4px;
      outline: none;
      border: none;

      &:disabled {
        color: $disabled-color;
      }

      &:active:not([disabled]) {
        filter: brightness(130%);
      }

      .icon {
        svg {
          fill: $secondary-color;
        }
      }
    }

    // Standard variant is a solid color
    &.outline {
      border: 1px solid $secondary-color;
      color: $secondary-color;
      outline: none;
      background: transparent;
      border-radius: 4px;
      padding: 0 20px;

      &:disabled {
        color: $disabled-color;
        border: 1px solid $disabled-color;
      }

      &:active {
        background: $secondary-color;
        color: white;
      }

      .icon {
        svg {
          fill: $secondary-color;
        }
      }
    }
  }
}
